/**
 * Address formatting shared by the Payees, Payments and Payments 2025 screens (AB#6872).
 *
 * PURE module: no React, MUI, axios or auth imports.
 */

/** The address parts formatMailingAddress reads; every part is optional. */
export interface MailingAddressParts {
  address1?: string | null;
  address2?: string | null;
  address3?: string | null;
  city?: string | null;
  state?: string | null;
  postalCode?: string | null;
}

/** One-line mailing address: "1 Main St, Apt 2, Macon, GA 31201" (blank parts skipped). */
export function formatMailingAddress(a?: MailingAddressParts | null): string {
  if (!a) return "";
  const street = [a.address1, a.address2, a.address3]
    .map((part) => (part ?? "").trim())
    .filter(Boolean)
    .join(", ");
  const region = [(a.state ?? "").trim(), (a.postalCode ?? "").trim()]
    .filter(Boolean)
    .join(" ");
  return [street, (a.city ?? "").trim(), region].filter(Boolean).join(", ");
}
